import { SxProps, Theme } from '@mui/material';
import { fullBleed, gradients, minHeightDvh } from '../../theme/mixins';

// Auth screens sit on the same soft hero wash as the landing page, so signing in
// feels continuous with the marketing site rather than like a bare form.
export const pageWrapperStyles: SxProps<Theme> = {
    ...fullBleed,
    background: gradients.heroWash,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    py: { xs: 6, md: 10 },
    px: 2,
    ...minHeightDvh('calc(100dvh - 200px)'),
};

export const logoBoxStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mb: 4,
};

export const cardStyles: SxProps<Theme> = {
    maxWidth: 440,
    width: '100%',
    boxShadow: '0 20px 48px rgba(16,24,40,0.10)',
    border: '1px solid rgba(16,24,40,0.06)',
};

export const cardContentStyles: SxProps<Theme> = { p: { xs: 3, sm: 4 } };
export const headerBoxStyles: SxProps<Theme> = { textAlign: 'center', mb: 3 };
export const usernameFieldStyles: SxProps<Theme> = { mb: 2 };
export const passwordFieldStyles: SxProps<Theme> = { mb: 2 };

// Only rendered for an account that belongs to several clinics, and sized to match the two
// fields above it so the card does not visibly change shape when it appears.
export const clinicFieldStyles: SxProps<Theme> = { mb: 2 };

export const signInButtonStyles: SxProps<Theme> = {
    mt: 3,
    mb: 2,
    py: 1.5,
    fontSize: '1.05rem',
    fontWeight: 600,
};

export const linkBoxStyles: SxProps<Theme> = { textAlign: 'center', mt: 2 };
export const registerBoxStyles: SxProps<Theme> = { textAlign: 'center', mt: 3 };

// Links use the primary rather than the secondary. The secondary is the accent and is
// chosen per clinic, so it can land anywhere on the lightness scale -- the old brand's
// gold sat near 1.7:1 on white, well below the WCAG AA floor for text. Link colour needs
// the half of the palette that is reliably the darker one.
export const getForgotPasswordLinkStyles = (theme: Theme): SxProps<Theme> => {
    return { color: theme.palette.primary.main, fontWeight: 500 };
};

export const getRegisterLinkStyles = (theme: Theme): SxProps<Theme> => {
    return { color: theme.palette.primary.main, fontWeight: 600 };
};
